import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { media } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    main: {
      flexGrow: 1,
      paddingLeft: 15,
      paddingRight: 15,
      paddingBottom: 15,

      [media.tablet]: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 30,
      },

      [media.desktop]: {
        paddingLeft: 53,
        paddingRight: 53,
        paddingBottom: 53,
      },
    },
    content: {
      marginTop: 47,
      [media.tablet]: {
        marginTop: 50,
      },
      [media.desktop]: {
        marginTop: 70,
      },
    },
    section: {
      margin: '0 auto',
      width: '100%',
      color: 'white',
      maxWidth: 940,
      paddingTop: 43,
    },
  });
};
